import './TimelineRecord.scss';
import { convertISODateToShortDate } from '@sonar-software/sonar-ts-lib';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getChangeTypeToChangeLabel } from '@timeline/@arch/lib';
import { SonarRecord } from '@ui/records';
import { CodeComparison, ExpandCarat } from '@ui/general';
import { FileAddOutlined, RobotOutlined } from '@ant-design/icons';
import { off, on } from '@lib/events';
import React, { useCallback, useState } from 'react';
import { useOnMount, useOnUnmount } from '@hooks';
export const TimelineRecord = ({ parentSonarObjectId, record }) => {
    var _a, _b;
    const [isExpanded, setIsExpanded] = useState(true);
    const isExpandable = Boolean(record.change.changeDetail);
    const handleClick = useCallback(() => setIsExpanded((value) => !value), []);
    const handleExpand = useCallback(() => setIsExpanded(true), []);
    const handleCollapse = useCallback(() => setIsExpanded(false), []);
    useOnMount(() => {
        if (!isExpandable) {
            return;
        }
        on(`periscope-timeline-${parentSonarObjectId}:expandAll`, handleExpand);
        on(`periscope-timeline-${parentSonarObjectId}:collapseAll`, handleCollapse);
    });
    useOnUnmount(() => {
        if (!isExpandable) {
            return;
        }
        off(`periscope-timeline-${parentSonarObjectId}:expandAll`, handleExpand);
        off(`periscope-timeline-${parentSonarObjectId}:collapseAll`, handleCollapse);
    });
    const labelBase = getChangeTypeToChangeLabel(record.change.changeType);
    const label = isExpandable ? `${labelBase} - ${record.change.changeDetail}` : labelBase;
    return (React.createElement("div", { className: 'timeline-record' },
        React.createElement(SonarRecord, { name: React.createElement(React.Fragment, null,
                isExpandable ?
                    React.createElement(RobotOutlined, { className: 'timeline-record-icon' }) :
                    React.createElement(FileAddOutlined, { className: 'timeline-record-icon' }),
                React.createElement("span", { className: 'timeline-record-label' }, label),
                isExpandable &&
                    React.createElement(ExpandCarat, { className: 'timeline-record-expand', expanded: isExpanded, onClick: handleClick })), onClick: isExpandable ? handleClick : undefined, secondaryInfo: React.createElement(React.Fragment, null,
                React.createElement("span", null, record.lastModifiedByName),
                React.createElement("span", { className: 'timeline-record-timestamp' }, convertISODateToShortDate(record.change.timestamp))), sonarObjectId: record.sonarObjectId }, isExpandable && isExpanded &&
            React.createElement("div", { className: 'timeline-record-diff-row' },
                React.createElement(CodeComparison, { newCode: (_a = record.change.newValue) !== null && _a !== void 0 ? _a : COPY_SPECIFIC.NONE_PARENTHETICAL, oldCode: (_b = record.change.oldValue) !== null && _b !== void 0 ? _b : COPY_SPECIFIC.NONE_PARENTHETICAL })))));
};
